import "./edit-reward-event.scss";

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormRewardEvent from "../form-reward-event/form-reward-event";
import { useEditRewardEvent } from "./edit-reward-event.hook";

export function EditRewardEvent() {
  const {
    rewardEventData,
    isLoading,
    rewardEventError,
    formMethod,
    actions,
    isAllLevel,
    handleBack,
    handleAction,
    allLevelChange,
  } = useEditRewardEvent();

  const title = rewardEventData?.name ? (
    <h1> {rewardEventData?.name}</h1>
  ) : (
    <h1>Edit Reward Event</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormRewardEvent
          hasLevel={!!rewardEventData?.level}
          allLevelChange={allLevelChange}
        />
      </section>
    </div>
  );

  return (
    <div id="EditRewardEvent" className="reward-event">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {rewardEventError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditRewardEvent;
